<div style="width: 1000px; height: 750px;" data-cy="ar-create-transaction">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="ar-create-transaction-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-create-transaction-header">
      <div class="section-header-title" data-cy="ar-create-transaction-title">
        {{ this.isCreate ? 'Choose Procedure' : 'Choose Procedure' }}
      </div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;" data-cy="ar-create-transaction-content">
      <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="ar-create-transaction-spinner"></app-tdo-progress-spinner>
      <div *ngIf="!isLoading" style="flex: 1; overflow-y: hidden;" data-cy="ar-create-transaction-loaded-content">

<!--          body of modal-->

        <div style="display: flex" data-cy="ar-create-transaction-type-container">
          <div *ngIf="!isCodeEditSingle" style="flex:1" data-cy="ar-create-transaction-explosion-container">
            <mat-checkbox [(ngModel)]="useExplosionCodes" (ngModelChange)="onTypeChange($event)" data-cy="ar-create-transaction-explosion-checkbox">Explosion code</mat-checkbox>
          </div>
        </div>

<!--    fees to select-->
        <div *ngIf="!useExplosionCodes" style="flex: 1; overflow-y: auto; margin-top: 2px;" class="table-height" data-cy="ar-create-transaction-fees-container">
          <tdo-table [dataSource]="feeScheduleItems"
                     [isMultiSelection]="false" [isSearchable]="true" [isUsePaginator]="true"
                     [searchPredicate]="searchPredicate"
                     [searchInputValue]="searchCode"
                     (rowSelected)="onRowSelected($event)"
                     data-cy="ar-create-transaction-fees-table">
<!--            need to add property to set searchCode-->

            <tdo-table-column displayName="Procedure" propertyName="Description" isSortable="true" [rowTemplate]="desc" data-cy="ar-create-transaction-fees-col-procedure">
              <ng-template #desc let-row>
                <div *ngIf="row.model.Description" data-cy="ar-create-transaction-fees-procedure">{{ row.model.Description }}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Code" propertyName="Code" isSortable="true" [rowTemplate]="code" data-cy="ar-create-transaction-fees-col-code">
              <ng-template #code let-row>
                <div *ngIf="row.model.Code" data-cy="ar-create-transaction-fees-code">{{ row.model.Code }}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Fee" propertyName="Fee" isSortable="true" [rowTemplate]="fee" data-cy="ar-create-transaction-fees-col-fee">
              <ng-template #fee let-row>
                <div *ngIf="row.model.Fee" data-cy="ar-create-transaction-fees-fee">{{ row.model.Fee | currency }}</div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>

<!--    explosion codes-->
        <div *ngIf="useExplosionCodes" style="flex: 1; overflow-y: auto; margin-top: 2px;" class="table-height" data-cy="ar-create-transaction-explosion-list-container">
          <tdo-table [dataSource]="explosionCodes"
                     [isMultiSelection]="false" [isSearchable]="true" [isUsePaginator]="true"
                     [searchPredicate]="searchPredicateExplosion" (rowSelected)="onRowSelectedExploded($event)"
                     data-cy="ar-create-transaction-explosion-table">

            <tdo-table-column displayName="Procedure" propertyName="Name" isSortable="true" [rowTemplate]="desc" data-cy="ar-create-transaction-explosion-col-procedure">
              <ng-template #desc let-row>
                <div *ngIf="row.model.Name" data-cy="ar-create-transaction-explosion-procedure">{{ row.model.Name }}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Code(s)" propertyName="ExplosionID" isSortable="true" [rowTemplate]="code" data-cy="ar-create-transaction-explosion-col-codes">
              <ng-template #code let-row>
                <span *ngFor="let code of row.model.dataInsuranceExplosionCodes; let j = index" data-cy="ar-create-transaction-explosion-code">{{ j === row.model.dataInsuranceExplosionCodes.length-1 ? code.Code : code.Code + ', ' }}</span>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>

        <div style="background-color: var(--tdo-subnav-color); padding: 10px 10px 10px 10px" data-cy="ar-create-transaction-teeth-section">

          <div style="display: flex; padding-top: 5px" data-cy="ar-create-transaction-teeth-container">
            <div style="flex-basis: 140px" data-cy="ar-create-transaction-teeth-label">Teeth to be billed:</div>
            <div *ngFor="let tooth of caseWorkItemTeeth" style="flex-basis: 70px" data-cy="ar-create-transaction-tooth-item">
              <mat-checkbox [(ngModel)]="tooth.isSelected" data-cy="ar-create-transaction-tooth-checkbox"></mat-checkbox>
              #{{ tooth.Notation }}
            </div>
            <div style="flex:1; text-align: right" *ngIf="this.isDefaultInsurance && this.data.transactionItemID === null" data-cy="ar-create-transaction-fee-adjustment-container">
              <mat-radio-group
                aria-labelledby="example-radio-group-label"
                class="example-radio-group"
                [ngModel]="selectedFeeAdjustment"
                data-cy="ar-create-transaction-fee-adjustment-group">
                <mat-radio-button class="example-radio-button" *ngFor="let adj of this.feeDiscounts" [matTooltip]="getDiscountAmountForTooltip(adj)" (click)="setSelectedFeeAdjustment(adj)" data-cy="ar-create-transaction-fee-adjustment-option">
                  <mat-label data-cy="ar-create-transaction-fee-adjustment-label">{{adj.DiscountName.replace("Level","")}}</mat-label>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="ar-create-transaction-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="ar-create-transaction-footer-spacer"></div>
      <button (click)="close(false)" class="tdo-button tdo-close" style="margin-right: 10px;" data-cy="ar-create-transaction-cancel-btn">Cancel</button>
      <button (click)="submitTransactions()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="ar-create-transaction-ok-btn">Ok</button>
    </div>
  </div>
</div>
